import { ApplicationError } from '@/api/ApplicationError';

export class ApiResponseError extends ApplicationError {
  statusCode: number;
  errorName?: string;

  constructor(message: string, statusCode: number, errorName?: string) {
    super(message);

    this.name = 'ApiResponseError';
    this.statusCode = statusCode;
    this.errorName = errorName;

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if ('captureStackTrace' in Error && typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
